<template>
    <b-container fluid>
        <header-buttons
                :buttons="headerButtons"
                @onSaveMatch="saveMatch"
                @onShowModalExtract="showModalExtract"
        ></header-buttons>
        <b-row class="AdminMatchDetail">
            <b-col cols="12" md="5">
                <div class="AdminMatchDetail-logo">
                    <img :src="srcLogo" alt="logo"/>
                    <div class="AdminMatchDetail-info">
                        <p>VS</p>
                        <h3 class="text-uppercase text-truncate">{{match.opponent}}</h3>
                        <div class="small">{{competition}}</div>
                        <p>{{match.date}}</p>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="7">
                <admin-match-form @onChangeMatch="changeMatch"
                                  :matches="matches"
                                  :match="match">
                </admin-match-form>
            </b-col>
        </b-row>
        <hr>
        <template v-if="match.ref_partita">
            <b-row
                class="mt-3"
                v-if="match.sectors">
                <b-col
                    v-for="(sector, index) in match.sectors" v-bind:key="index"
                    cols="12" md="3" class="mb-3">
                    <admin-matches-sector-container
                        :busy="sectorBusy(sector)"
                        :sector="sector">
                    </admin-matches-sector-container>
                </b-col>
            </b-row>
            <hr>
        </template>

        <b-row class="mt-3" v-if="match.id">
            <b-col cols="12" class="mb-3">
                <h3>Richieste partita</h3>
            </b-col>
            <b-col cols="12" class="mb-3">
                <admin-matches-requests-table :match="match">
                </admin-matches-requests-table>
            </b-col>
        </b-row>

        <inter-modal
                title-icon="flaticon-group"
                :buttonPrimary="buttonPrimary"
                title="Estrai Contatti"
                :visible="showModal"
                size="sm"
                @onPrimaryClick="extractTickets">
            <b-container>
                <b-row>
                    <b-col v-for="(status, indexStatus) in requestStatuses" v-bind:key="indexStatus" cols="12"
                           class="my-2">
                        <div class="d-flex">
                            <div>
                                <b-form-checkbox v-model="status.checked" switch>
                                    <span class="text-uppercase">{{status.label}}</span>
                                </b-form-checkbox>
                            </div>
                            <div class="ml-auto">
                                <span v-bind:class="status.checked ? 'text-success' : 'text-warning'"
                                      class="text-uppercase small">
                                    {{ status.checked ? 'Includi' : 'Escludi'}}
                                </span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col cols="12" class="my-2">
                        <inter-select
                                label="Filtro biglietti"
                                v-model="filterTickets"
                                :optionSelected="filterTickets"
                                :options="filterTicketOptions"
                        ></inter-select>
                    </b-col>
                </b-row>
            </b-container>
        </inter-modal>
    </b-container>
</template>

<script>
    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import AdminMatchForm from "../forms/AdminMatchForm";
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import Match from "@/models/Match";
    import AdminMatchesSectorContainer from "../components/admin-matches-sector-container/AdminMatchesSectorContainer";
    import _ from 'lodash';
    import AdminMatchesRequestsTable from "../components/AdminMatchesRequestsTable";
    import InterModal from "../../../components/modal/InterModal";
    import Utils from '@/utils';
    import InterSelect from "../../../components/form/inter-select/InterSelect";

    export default {
        name: "AdminMathDetailView",
        components: {
            InterSelect,
            InterModal, AdminMatchesRequestsTable, AdminMatchesSectorContainer, AdminMatchForm, HeaderButtons
        },
        data() {
            return {
                // headerButtons: [
                //     {
                //         label: 'Estrai biglietti',
                //         onClick: 'onShowModalExtract',
                //     },
                //     {
                //         label: 'Salva Partita',
                //         onClick: 'onSaveMatch',
                //         confirm: true
                //     }
                // ],
                matches: [],
                match: Object.assign({}, Match),
                srcLogo: require('@/assets/media/logo.svg'),
                showModal: false,
                buttonPrimary: {
                    label: 'Estrai',
                    confirm: true
                },
                requestStatuses: Utils.getRequestStatuses(),
                filterTickets: 'all',
                filterTicketOptions: [
                    {value: 'all', name: 'Tutti'},
                    {value: 'with', name: 'Con biglietto'},
                    {value: 'without', name: 'Senza biglietto'}
                ]
            }
        },
        computed: {
            ...mapGetters([
                'currentMatch',
                'sectors',
            ]),

            competition: function() {
                if(!_.isEmpty(this.currentMatch) && this.currentMatch.archivioPartita
                    && this.currentMatch.archivioPartita.competition ) {
                    return this.currentMatch.archivioPartita.competition.name;
                } else {
                    return '';
                }
            },

            headerButtons: function () {
                let buttons = [];

                buttons.push({
                    label: 'Salva Partita',
                    onClick: 'onSaveMatch',
                    confirm: true
                });

                if(this.match.id) {
                    buttons.push({
                        label: 'Estrai biglietti',
                        onClick: 'onShowModalExtract',
                    });

                }
                return buttons;
            }
        }
        ,
        mounted() {
            this.$root.$on('bv::modal::hide', () => {
                this.showModal = false;
            });
            this.match = !_.isEmpty(this.currentMatch)
                ? Object.assign({}, this.currentMatch)
                : Object.assign({}, Match);
            const breadcrumb = !_.isEmpty(this.currentMatch)
                ? (this.match.opponent + ' - ' + this.match.date)
                : 'Nuova partita';

            this.setBreadcrumbActive(breadcrumb);

            // if (!this.match.sectors.length) {
            //     this.match.sectors = this.sectors;
            // }

            this.adminMatchesSelect()
            .then((resp) => {
                this.matches = resp;
            }).catch();
        }
        ,
        methods: {

            ...
                mapActions({
                    adminMatchesSave: 'adminMatchesSave',
                    commonDownloadFile: 'commonDownloadFile',
                    adminMatchesSelect: 'adminMatchesSelect',
                }),

            ...
                mapMutations([
                    'setBreadcrumbActive'
                ]),

            sectorBusy:

                function (sector) {
                    let value = 0;
                    if (this.match.requests) {
                        _.forEach(this.match.requests, (item) => {
                            if (item.sector_id === sector.id) {
                                value += item.details.length;
                            }
                        });
                    }

                    return value;
                }

            ,
            saveMatch: function () {
                this.adminMatchesSave(Object.assign({}, this.match))
                    .then((data) => {
                        this.$bvToast.toast('Partita salvata correttamente', {
                            title: 'Success',
                            variant: 'success'
                        });
                        if (!this.match.id) {
                            this.$router.push({name: 'admin.matches.show', params: {id: data.id}});
                        } else {
                            this.setBreadcrumbActive(this.match.opponent + ' - ' + this.match.date);
                        }

                    }).catch(() => {

                    this.$bvToast.toast('Errore nel salvataggio', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })
            }
            ,

            showModalExtract: function () {
                this.showModal = true;
            }
            ,

            extractTickets: function () {
                let statuses = [];
                _.map(this.requestStatuses, (status) => {
                    if (status.checked) {
                        statuses.push(status.name);
                    }
                });
                this.commonDownloadFile({
                    url: 'exports/matches/' + this.match.id + '/requests',
                    filename: 'MatchRequest.xlsx',
                    method: 'post',
                    auth: true,
                    data: {
                        requestStatuses: statuses,
                        filterTickets: this.filterTickets
                    }
                }).then()
                    .catch(() => {
                        this.$bvToast.toast('Problemi nella estrazione', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    })
            }
            ,
            changeMatch: function (item) {
                if (item && item.name) {
                    const value = item.name.split(' [ ');
                    this.match.opponent = value[0];
                    this.match.date = Utils.setDateFormatUSA(value[1] ? value[1].replace(' ] ', '') : '');
                    this.match.ref_partita = item.value
                    if (!isNaN(Number(item.value))) {
                        this.match.sectors = _.filter(this.sectors, (sector) => sector.code !== 'UN')
                    } else {
                        this.match.sectors = _.filter(this.sectors, (sector) => sector.code === 'UN')
                    }

                }
            }
        }
    }
</script>

<style scoped>

</style>
